"use client";

import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

export default function Mixpanel() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN as string, {
        debug: process.env.NEXT_PUBLIC_SAM_ENV !== "production",
        track_pageview: "full-url",
        persistence: "localStorage",
      });
    }
  }, []);

  return null;
}
